import { HashRouter as Router, Routes, Route, } from "react-router-dom";
import Home from "./pages/Home";
import Aboutus from "./pages/Aboutus";
import TermsAndCondition from "./pages/TermsCondition";
import Privacy from "./pages/Privacy";
import Demo from "./pages/Demo";
import Price from "./pages/Price";
import Company from "./pages/Company"
import ThankYou from "./pages/ThankYou";
import Campaign from "./pages/Campaign";
import ThankYouCampaign from "./pages/ThankYouCampaign";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <Login />
        }></Route>

        <Route path="/about" element={<Aboutus />}></Route>
        <Route path="/terms" element={<TermsAndCondition />}></Route>
        <Route path="/privacy" element={<Privacy />}></Route>
        <Route path="/demo" element={<Demo />}></Route>
        <Route path="/pricing" element={<Price />}></Route>
        <Route path="/checkout" element={<Company />}></Route>
        <Route path="/thankyou" element={<ThankYou />}></Route>
        <Route path="/campaign" element={<Campaign></Campaign>}></Route>
        <Route path="/thankyou_campaign" element={<ThankYouCampaign></ThankYouCampaign>}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/forgotPassword" element={<ForgotPassword />}></Route>
        <Route path="/resetPassword" element={<ResetPassword></ResetPassword>}></Route>
      </Routes>
    </Router>
  );
}

export default App;
